module.exports = __webpack_public_path__ + "img/login-create-account.4cac3183.png";